/* eslint-disable no-unused-vars */

import { message } from 'antd';
import { useDispatch, useSelector } from 'dva';
import styles from './index.less?modules';
import classnames from 'classnames';
import { useState, useEffect, useCallback } from 'react';
import SearchGroup from './components/search_group/SearchGroup';
import TablePage from './components/table_page/TablePage';
// import ButtonML from '@/components/button_ml/ButtonML';
import ModalML from '@/components/modal_ml/ModalML';
import AddMember from './add/components/add_member/AddMember';
import EditMember from './add/components/edit_member/EditMember';
import OperationLog from './components/operate_log/OperationLog';
import { history } from 'umi';

const MemberManagement = (props) => {
  const dispatch = useDispatch();
  const loadingEffect = useSelector((state) => state.loading);
  const loading = loadingEffect.effects['ruleginMM/getMemberList'];
  const datas = useSelector((state) => state.ruleginMM.getMemberList);
  const [params, setParams] = useState({});
  const [modalVisible, setVisible] = useState(false);
  const [modalVisible2, setVisible2] = useState(false);
  const [modalVisible3, setVisible3] = useState(false);
  const [logTableData, setLogTableData] = useState([]);
  const [memberInfo, setMemberInfo] = useState({});
  const [itemInfo, setItemInfo] = useState({});

  const handleSearch = (par) => {
    par.modelName = par.modelName ? par.modelName : '';
    setParams({ ...par });
  };

  const pageSizeChange = (val) => {
    // setParams({
    //   ...params,
    //   page: 1,
    //   limit: val,
    // });
  };

  const pageNumChange = ({ current }) => {
    // setParams({
    //   ...params,
    //   page: current,
    // });
  };

  //选择多个table
  const onSelect = () => {
    // setIdArr(val);
  };
  // 获取会员列表
  const fetchData = useCallback(() => {
    dispatch({
      type: 'ruleginMM/getMemberList',
      payload: {
        values: {
          ...params,
        },
      },
    });
  }, [dispatch, params]);

  // 发起请求
  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const add = (e) => {
    setVisible(true);
  };
  const edit = (e) => {
    setItemInfo(e);
    setVisible2(true);
  };

  // 新增弹出
  const handleOk = (e) => {
    setVisible(false);
    setMemberInfo(e.data);
    fetchData();
  };
  // 新增弹入
  const handleCancel = () => {
    setVisible(false);
  };

  // 编辑弹出
  const handleOk2 = (e) => {
    setVisible2(false);
    fetchData();
  };
  // 编辑弹入
  const handleCancel2 = () => {
    setVisible2(false);
  };
  // 操作日志
  const handleCancel3 = () => {
    setVisible3(false);
  };

  // 删除
  const handleMemberDelete = (e) => {
    dispatch({
      type: 'ruleginMM/deleteModel',
      payload: {
        values: e.id,
      },
      callback: (data) => {
        // message.success(data.message);
        if (data && JSON.stringify(data.code) !== '0') {
          message.warning(data.message);
          return;
        }
        message.success('删除成功');
        fetchData();
      },
    });
  };

  // 导入
  const uploadAction = (e) => {
    const formData = new FormData();
    formData.append('uploadFile', e);
    dispatch({
      type: 'ruleginMM/uploadFile',
      payload: {
        values: formData,
      },
      callback: (res) => {
        if (res && res.code === 2) {
          message.error('导入文件内容不符合规格');
        } else {
          message.success('导入成功');
        }
      },
    });
  };

  const moreEdit = (a, b) => {
    if (a === '2') {
      dispatch({
        type: 'ruleginMM/exportModel',
        payload: {
          values: b.id,
        },
        callback: (res) => {
          const blob = new Blob([res], {
            type: 'application/json; charset=utf-8',
          });
          const fileName = new Date().getTime() + '.json';
          if (window.navigator.msSaveOrOpenBlob) {
            // IE10+
            navigator.msSaveBlob(blob, fileName);
            message.success('导出成功');
          } else if ('download' in document.createElement('a')) {
            // 非IE
            const link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = fileName;
            document.body.appendChild(link);
            link.style.display = 'none';
            link.click();
            window.URL.revokeObjectURL(link.href);
            link.remove();
            message.success('导出成功');
          } else {
            message.error('当前浏览器不支持!');
          }
        },
      });
    } else if (a === '3') {
      dispatch({
        type: 'ruleginMM/getLog',
        payload: {
          values: b.id,
        },
        callback: (res) => {
          setLogTableData(res);
        },
      });
      setVisible3(true);
    }
  };

  // 进入模型名称详情页
  const goToModalDetail = (e) => {
    history.push({
      pathname: '/bre/mm/md',
      query: {
        modelID: e.id,
        editable: e.editable,
      },
    });
  };

  let tableData = datas || [];

  return (
    <div className={styles.mm_content}>
      <div
        className={classnames(styles.search_group, styles.single_component1)}
      >
        <SearchGroup handleSearch={(par) => handleSearch(par)} onAdd={add} />
      </div>
      <div className={classnames(styles.table_page, styles.single_component)}>
        {/* 默认使用loading包裹，使用tabel的loading会闪屏，且加载时tabel列头也加载 */}
        <TablePage
          pagination={{
            // total: total,
            pageSize: params.limit,
            page: params.page,
          }}
          onSelect={onSelect}
          tableData={tableData}
          // pageSizeChange={pageSizeChange}
          // pageNumChange={pageNumChange}
          loadingstatus={loading}
          deleteItem={handleMemberDelete}
          edit={edit}
          menuClick={moreEdit}
          goToModal={goToModalDetail}
          uploadAction={uploadAction}
        />
      </div>
      <ModalML title="新增" visible={modalVisible} handleCancel={handleCancel}>
        <AddMember handleOk={handleOk} handleCancel={handleCancel} />
      </ModalML>
      <ModalML
        title="编辑"
        visible={modalVisible2}
        handleCancel={handleCancel2}
      >
        <EditMember
          itemInfo={itemInfo}
          handleOk={handleOk2}
          handleCancel={handleCancel2}
        />
      </ModalML>
      <ModalML
        title="操作日志"
        // width="70vw"
        visible={modalVisible3}
        handleCancel={handleCancel3}
      >
        <OperationLog tableData={logTableData} />
      </ModalML>
    </div>
  );
};

export default MemberManagement;
